export default __webpack_public_path__ + "static/media/memoria fotografica.dc89d88e.png";